import { CalendarIcon, GlobeIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatDate } from './domain-overview.helper'

export interface DomainInfoCardProps {
  domain: string
  registrar: string
  registeredAt: string
  expiresAt: string
}

export const DomainInfoCard: React.FC<DomainInfoCardProps> = ({
  domain,
  registrar,
  registeredAt,
  expiresAt,
}): ReactNode => (
  <Card className="domain-info-card">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center gap-2 text-base">
        <GlobeIcon className="size-4" />
        Domain Information
      </CardTitle>
    </CardHeader>
    <CardContent className="grid gap-3 text-sm">
      <div className="flex justify-between">
        <span className="text-muted-foreground">Domain</span>
        <span className="font-medium">{domain}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Registrar</span>
        <span className="font-medium">{registrar}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-muted-foreground">
          <CalendarIcon className="size-3" />
          Registered
        </span>
        <span className="font-medium">{formatDate(registeredAt)}</span>
      </div>
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-muted-foreground">
          <CalendarIcon className="size-3" />
          Expires
        </span>
        <span className="font-medium">{formatDate(expiresAt)}</span>
      </div>
    </CardContent>
  </Card>
)
